module.exports = __webpack_public_path__ + "img/img03.89a463c4.png";